document.documentElement.classList.remove('no-js');

(function () {
  const COD_TARGET = '#cod-order-form';

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-scroll-to-cod]');
    if (!trigger) return;
    event.preventDefault();
    const target = document.querySelector(COD_TARGET);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const firstInput = target.querySelector('input:not([type="hidden"]), select, textarea');
    window.setTimeout(() => firstInput && firstInput.focus({ preventScroll: true }), 450);
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-qty-change]');
    if (!button) return;
    const wrapper = button.closest('[data-qty]');
    const input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;
    const step = Number(button.dataset.qtyChange || 0);
    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : 999;
    const next = Math.min(max, Math.max(min, Number(input.value || 1) + step));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('.cod-form');
    if (!form) return;
    event.preventDefault();

    const submit = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-cod-status]');
    const redirect = form.dataset.redirect || '/checkout';
    const originalText = submit ? submit.textContent : '';

    if (submit) {
      submit.disabled = true;
      submit.textContent = submit.dataset.loadingText || 'جاري تأكيد الطلب...';
    }
    if (status) {
      status.className = 'cod-status';
      status.textContent = '';
    }

    try {
      const formData = new FormData(form);
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'تعذر إضافة المنتج للسلة');

      if (status) {
        status.className = 'cod-status is-visible is-success';
        status.textContent = 'تم حفظ معلومات الطلب، جاري الانتقال...';
      }
      window.location.assign(redirect);
    } catch (error) {
      if (status) {
        status.className = 'cod-status is-visible is-error';
        status.textContent = error.message || 'وقع خطأ، حاول مرة أخرى.';
      }
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalText;
      }
    }
  });
})();
